import { render, staticRenderFns } from "./idCode.vue?vue&type=template&id=b899e8e4&scoped=true"
import script from "./idCode.vue?vue&type=script&lang=js"
export * from "./idCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899e8e4",
  null
  
)

export default component.exports